import { map } from 'lodash';

export const mergeById = (a1, a2) =>
	map(a1, (itm) => ({
		...itm,
		...a2.find((item) => item.id === itm.id && item),
	}));
